var $ = require('../internals/export');
var parseIntImplementation = require('../internals/number-parse-int');

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.parse-int.js
// module id = 1082
// module chunks = 0